import { render } from "./SwiperIconList.vue?vue&type=template&id=4633acb6&scoped=true&ts=true"
import script from "./SwiperIconList.vue?vue&type=script&lang=ts"
export * from "./SwiperIconList.vue?vue&type=script&lang=ts"

import "./SwiperIconList.vue?vue&type=style&index=0&id=4633acb6&lang=scss&scoped=true"
import "./SwiperIconList.vue?vue&type=style&index=1&id=4633acb6&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4633acb6"]])

export default __exports__